export default __webpack_public_path__ + "static/media/ttSite.51ac0a94.png";